import { useEffect, useState } from "react";
import CtaButton from "./CtaButton";

/** barra fixa no rodapé (mobile only) que aparece depois que o usuário passa da hero */
const StickyCta = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.85);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={[
        "e21-glass fixed inset-x-0 bottom-0 z-40 border-x-0 border-b-0 p-3",
        "pb-[calc(0.75rem+env(safe-area-inset-bottom))]",
        "transition-transform duration-300 ease-out md:hidden",
        show ? "translate-y-0" : "translate-y-full",
      ].join(" ")}
    >
      <CtaButton label="entrar na lista de espera" full />
    </div>
  );
};

export default StickyCta;
